import { useState } from 'react';
import { api } from '@/lib/api';
import type { FootingAnalyzeRequest } from './types';

type Format = 'pdf' | 'xlsx';

const PATHS: Record<Format, string> = {
  pdf: '/api/zapatas/isolated/export/pdf',
  xlsx: '/api/zapatas/isolated/export/xlsx',
};

const MIME: Record<Format, string> = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

function timestamp(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
}

export function useExportFooting() {
  const [busy, setBusy] = useState<Format | null>(null);
  const [error, setError] = useState<string | null>(null);

  const trigger = async (
    format: Format,
    request: FootingAnalyzeRequest,
    snapshot3d: string | null = null,
  ) => {
    setBusy(format);
    setError(null);
    try {
      const payload: FootingAnalyzeRequest = { ...request, snapshot_3d: snapshot3d };
      const res = await api.post<Blob>(PATHS[format], payload, {
        responseType: 'blob',
        headers: { Accept: MIME[format] },
      });
      const blob = new Blob([res.data], { type: MIME[format] });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `alphaconcreto-zapata-${timestamp()}.${format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e: any) {
      setError(e?.message ?? 'Error al exportar');
    } finally {
      setBusy(null);
    }
  };

  return { trigger, busy, error };
}
